import { Box, BoxProps, ButtonNew, ButtonProps, ColorOptions, Icon, Spacer, TextNew } from '@jfs/ui-new'
import { FC } from 'react'

interface HeaderProps {
  onDuplicate: () => void
  onResend?: () => void
  onCancel?: () => void
  onDismiss: () => void
  data: { status: string; pushSmsTo: string; pushEmailTo: string }
  plId: string
}
const Header: FC<HeaderProps> = (props: HeaderProps) => {
  const { plId, data, onDuplicate, onResend, onCancel, onDismiss } = props
  const { status = '', pushSmsTo = '', pushEmailTo = '' } = data
  return (
    <Box {...styles.container}>
      <Box>
        <TextNew type="titleBold18" color="BLACK_21" fontFamily={'jiotype-bold'}>
          {plId}
        </TextNew>
      </Box>
      <Box flexDirection="row">
        <ButtonNew
          testID="payLinkDuplicateBtn"
          {...styles.duplicate}
          onPress={() => onDuplicate && onDuplicate()}
          title="Duplicate"
        />
        <Spacer size={8} direction="horizontal" />
        {status === 'ISSUED' && ((pushSmsTo && pushSmsTo !== '') || (pushEmailTo && pushEmailTo !== '')) && (
          <>
            <ButtonNew
              {...styles.resend}
              title="Resend"
              testID="payLink-resed"
              onPress={() => onResend && onResend()}
            />
            <Spacer size={8} direction="horizontal" />
          </>
        )}
        {status === 'ISSUED' && (
          <>
            <ButtonNew
              {...styles.cancel}
              title="Cancel"
              testID="payLink-cancel"
              onPress={() => onCancel && onCancel()}
            />
            <Spacer size={8} direction="horizontal" />
          </>
        )}
        <Box onPress={onDismiss} testID="payLink-close" {...styles.close}>
          <Icon id="CLOSE" size="FONT_SIZE_LARGE_3P" color={'GREY_C' as ColorOptions} />
        </Box>
      </Box>
    </Box>
  )
}

export { Header }

const styles = {
  container: {
    justify: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    paddingHorizontal: 24,
    paddingVertical: 16,
    borderBottomColor: 'SEPARATOR' as ColorOptions,
    borderBottomWidth: 1,
  } as BoxProps,
  close: {
    alignSelf: 'center',
    paddingVertical: 8,
    underlayColor: 'WHITE',
  } as BoxProps,
  duplicate: {
    type: 'secondaryIconSmall',
    paddingHorizontal: 8,
    icon: 'DUPLICATE',
    borderColor: 'DISABLED_GREY',
    titleColor: 'BLACK_21',
    borderRadius: 'SMALL',
    borderWidth: 1,
    iconPaddingRight: 8,
  } as ButtonProps,
  resend: {
    paddingHorizontal: 8,
    icon: 'ICON_REFRESH',
    type: 'primaryIconSmall',
    borderRadius: 'SMALL',
    iconPaddingRight: 8,
  } as ButtonProps,
  cancel: {
    paddingHorizontal: 8,
    type: 'secondarySmall',
    borderColor: 'DISABLED_GREY',
    titleColor: 'BLACK_21',
    borderRadius: 'SMALL',
    borderWidth: 1,
  } as ButtonProps,
}
